import { Component, OnInit } from "@angular/core";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { TopTenPractitionerIndicatorData } from "src/app/ui/models/domains/pbm/indicators/top-ten-practitioner-data";
import { TopTenPractitionerIndicatorDataStrategy } from "src/app/ui/pages/home/indicator-data-strategies";
import { IndicatorMediator } from "src/app/ui/services/pbm/indicator-mediator";
import { IndicatorService } from "src/app/ui/services/pbm/indicator.service";

@Component({
  selector: "top-ten-practitioner-indicator",
  templateUrl: "./top-ten-practitioner-indicator.component.html",
  styleUrls: ["./top-ten-practitioner-indicator.component.scss"],
})
export class TopTenPractitionerIndicatorComponent implements OnInit {
  public topTenPractitionerData: TopTenPractitionerIndicatorData;
  public isLoading: boolean = true;

  constructor(private indicatorService: IndicatorService, private indicatorMediator: IndicatorMediator) {}

  async ngOnInit() {
    this.topTenPractitionerData = (await this.indicatorMediator.getIndicatorData(
      new TopTenPractitionerIndicatorDataStrategy(),
    )) as TopTenPractitionerIndicatorData;
    this.isLoading = false;
  }

  public async onFilterData(company: Company) {
    this.isLoading = true;
    if (company) this.topTenPractitionerData = await this.indicatorService.getTopTenPractitionerData([company.getFiscalNumber()]);
    else this.topTenPractitionerData = await this.indicatorService.getTopTenPractitionerData();
    this.isLoading = false;
  }

  public getTotal(): string {
    return this.topTenPractitionerData && this.topTenPractitionerData.getTotal();
  }

  public getTopTenPractitionerList() {
    return this.topTenPractitionerData && this.topTenPractitionerData.getItems();
  }

  public getPractitionerName(practitioner): string {
    return practitioner.networkName;
  }

  public hasTopTenPractitionerData(): boolean {
    return !!this.topTenPractitionerData && !!this.topTenPractitionerData.getItems().length;
  }

  public trackByFn = (index: number, item: any) => item.id;
}
